import { TransactionType } from '@/types';
import { StepArchetype } from '@/types/stepRun';

export enum WorkflowRunUpdatable {
    TriggerBatchAction = 'TriggerBatchAction',
}

export interface TriggerBatchActionRequest {
    targetStepRunIds: string[];
    transactionType: TransactionType;
    stepArchetype: StepArchetype;
    customRequestData: any;
}
